import script from "./ConfirmActionDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmActionDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmActionDropdown.vue?vue&type=style&index=0&id=6e7b4cf3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e7b4cf3"]])

export default __exports__